import { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  FaStore,
  FaShoppingCart,
  FaUndoAlt,
  FaTruck,
  FaBoxes,
  FaUtensils,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function StoreMenu() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const navigate = useNavigate();

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      direction="down"
      className="w-100"
    >
      <DropdownToggle caret color="primary" className="w-100">
        <FaStore className="me-2" /> Store Admin
      </DropdownToggle>
      <DropdownMenu className="w-100 shadow-lg rounded-3 p-2">
        <DropdownItem onClick={() => navigate("/store-admin/purchase")}>
          <FaShoppingCart className="me-2 text-primary" /> Purchase
        </DropdownItem>
        <DropdownItem onClick={() => navigate("/store-admin/rtn-purchase")}>
          <FaUndoAlt className="me-2 text-danger" /> Purchase Returns
        </DropdownItem>
        <DropdownItem onClick={() => navigate("/store-admin/suppliers")}>
          <FaTruck className="me-2 text-success" /> Suppliers
        </DropdownItem>
        <DropdownItem onClick={() => navigate("/store-admin/sku")}>
          <FaBoxes className="me-2 text-warning" /> Stock Management
        </DropdownItem>
        <DropdownItem onClick={() => navigate("/store-admin/consume")}>
          <FaUtensils className="me-2 text-info" /> Consumption
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
